import * as React from 'react';
import { parse } from 'query-string';
import request from '@/server/request';
import config from '@/server/config';

export default class Class extends React.Component<any, any> {
    private loadTimer: any;
    constructor(props: any) {
        super(props);
        this.state = {
            type: parse(this.props.location.search).type || '1', // 1.课堂 2.收藏
            list: [], // 列表
            page: 1, // 页码
            isLoading: true, // 是否加载中
            loadOver: false, // 是否全部加载完
        };
    }
    public render() {
        return (
            <section>
                <div className="class-head">
                    <div className="class-tab">
                        <a className={this.state.type === '1' ? 'active' : ''} href="/mobile/uc/build/class?type=1">我的课程</a>
                        <a className={this.state.type === '2' ? 'active' : ''} href="/mobile/uc/build/class?type=2">我的收藏</a>
                    </div>
                    <a className="class-home" href={`${config.WAPAPI}courses/`}>课堂首页<i></i></a>
                </div>
                <div className="class-body">
                    {
                        this.state.list.map((v: any, k: number) => {
                            return (
                                <div className="class-item" key={v.id}>
                                    <a href={`${config.WAPAPI}courses/${v.id}?type=${v.type}`}>
                                        <img src={`${config.API}courses/downLoadImg?annexId=${v.img3}`} alt="" />
                                        <strong>{v.title}</strong>
                                    </a>
                                    <div className="class-itemfunc">
                                        <p>{v.learnCount}人学习</p>
                                        <a className="btn-delete" href="javascript: void(0)" onClick={() => this.deleteAction(v.id, k)}>删除</a>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <p className="loading-tips">{this.state.loadOver ? '没有更多数据' : '数据加载中...'}</p>
            </section>
        )
    }
    public componentDidMount() { 
        this.getData();
        window.addEventListener('scroll', this.scrollAction.bind(this));
    }
    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));
        if (this.loadTimer) { 
            clearTimeout(this.loadTimer);
        }
        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
    }
    // 获取数据
    private async getData() { 
        const r = await request({
            url: `${config.API}courses/member/course/wap/${this.state.type}/myCourses?myCourseType=${this.state.type}&page=${this.state.page}&pageSize=10`
        });
        if (r.code === 1) { 
            const loadOver = r.obj.page.page >= r.obj.page.pages
            this.setState({
                list: [...this.state.list, ...r.obj.classCourses],
                isLoading: false,
                loadOver
            });
        }
    }
    /**
     * 加载更多
     * 滚动加载更多数据
     */
    private scrollAction() {
        if (this.state.isLoading || this.state.loadOver) { 
            return;
        }
        
        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {
            if (this.loadTimer) { 
                clearTimeout(this.loadTimer);
            }
            this.loadTimer = setTimeout(() => {
                this.loadMore();
             }, 500);
        }
    }
    // 加载更多文章内容
    private loadMore() { 
        this.setState({
            isLoading: true,
            page: this.state.page + 1
        }, () => { 
                this.getData();
        });
    }

    /**
     * 删除已学习课程
     * @param {number} id 课程id
     * @param {number} index 课程索引
     */
    private async deleteAction(id: number, index: number) {
        const r = await request({
            url: config.API + (this.state.type === '1' ? '/courses/member/course/delLearnCourse/' : '/courses/member/course/wap/collect/') + id
        });
        if (r.code === 1) { 
            const temp = this.state.list;
            temp.splice(index, 1);
            this.setState({
                list: temp
            }, () => { 
                    if (!this.state.loadOver && this.state.list.length < 5) { 
                        this.loadMore();
                    }
            });
        }
    }
}